import { render, staticRenderFns } from "./tab-select.vue?vue&type=template&id=7e9a4890&"
import script from "./tab-select.vue?vue&type=script&lang=js&"
export * from "./tab-select.vue?vue&type=script&lang=js&"
import style0 from "./tab-select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports